import DOMPurify from 'dompurify';

const YOUTUBE_HOSTS = new Set([
  'www.youtube.com',
  'youtube.com',
  'www.youtube-nocookie.com',
  'youtube-nocookie.com',
]);

let hookRegistered = false;

function registerYoutubeIframeHook() {
  if (hookRegistered) return;
  hookRegistered = true;

  DOMPurify.addHook('uponSanitizeElement', (node) => {
    if (node.nodeName !== 'IFRAME') return;

    const src = node.getAttribute('src');
    if (!src) {
      node.parentNode && node.parentNode.removeChild(node);
      return;
    }

    let url;
    try {
      url = new URL(src, window.location.origin);
    } catch {
      node.parentNode && node.parentNode.removeChild(node);
      return;
    }

    if (!YOUTUBE_HOSTS.has(url.hostname)) {
      node.parentNode && node.parentNode.removeChild(node);
      return;
    }

    node.setAttribute(
      'referrerpolicy',
      'strict-origin-when-cross-origin'
    );
  });
}

/**
 * Sanitize CMS HTML while allowing YouTube embed iframes only.
 * Allowed iframes get referrerpolicy="strict-origin-when-cross-origin" set automatically.
 */
export function sanitizeRichHtml(html) {
  if (typeof window === 'undefined') {
    return html ?? '';
  }

  registerYoutubeIframeHook();

  return DOMPurify.sanitize(html ?? '', {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: [
      'target',
      'src',
      'width',
      'height',
      'allow',
      'allowfullscreen',
      'frameborder',
      'referrerpolicy',
      'title',
    ],
  });
}
